import type { ChartMetaDTO } from '@/features/chartsView';
import { baseApi, getErrorMessage } from '@/shared/api';
import type { Meta, ROIBreakdownDataResponse } from '../model/types';
import type { GetDataParams } from './types';

export const getMeta = async (): Promise<Meta> => {
  const { data, error } = await baseApi.functions.invoke<{
    calendarInsightsMeta: ChartMetaDTO;
  }>('getComparisonViewMeta');

  if (!data) {
    const errorMessage = getErrorMessage(error);

    throw new Error(errorMessage);
  }

  return {
    defaultAxis: {
      dimension: 'media_source', // TODO: get from backend when ROI breakdown view configured
      metric: data.calendarInsightsMeta.defaultAxis.primaryMetric,
    },
    config: data.calendarInsightsMeta.config,
    dimensions: data.calendarInsightsMeta.dimensions,
    metrics: data.calendarInsightsMeta.metrics,
  };
};

export const getData = async ({
  split,
  metrics,
  cohortDateScale,
  cohortDateRange,
  revenueDateScale,
  revenueDateRange,
  probabilisticAttribution,
  dimensionsFilters,
  metricsFilters,
}: GetDataParams) => {
  const { data, error } =
    await baseApi.functions.invoke<ROIBreakdownDataResponse>(
      'getComparisonViewCalendarData',
      {
        body: {
          split,
          metrics,
          cohortDateScale,
          cohortDateRange,
          revenueDateScale,
          revenueDateRange,
          probabilisticAttribution,
          dimensionsFilters,
          metricsFilters,
        },
      },
    );

  if (!data) {
    const errorMessage = getErrorMessage(error);

    throw new Error(errorMessage);
  }

  return data;
};
